export default "__VITE_ASSET__Befe8tQJ__"